import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';
import { AddEditApi } from '../interfaces/productDivision.interface';
import queryString from 'query-string';

const list = (payload: any) => {
  const query = queryString.stringify(payload);
  return http.get(`${API_ENDPOINTS.listProductDivisions}?${query}`);
};

const add = (payload: AddEditApi) => {
  return http.post(API_ENDPOINTS.addProductDivision, payload);
};

const edit = (id: string, payload: AddEditApi) => {
  return http.put(`${API_ENDPOINTS.editProductDivision}/${id}`, payload);
};

const get = (id: string) => {
  return http.get(`${API_ENDPOINTS.getProductDivision}/${id}`);
};

const lookup = (payload: { searchText?: string }) => {
  const url = `${API_ENDPOINTS.lookupProductDivisions}?${queryString.stringify({ search: payload.searchText || '' })}`;
  return http.get(url);
};

const ProductDivisionService = {
  list,
  add,
  edit,
  get,
  lookup,
};

export default ProductDivisionService;
